import { render, staticRenderFns } from "./CappedValueDisplay.vue?vue&type=template&id=c3cfb74c"
import script from "./CappedValueDisplay.vue?vue&type=script&lang=js"
export * from "./CappedValueDisplay.vue?vue&type=script&lang=js"
import style0 from "./CappedValueDisplay.vue?vue&type=style&index=0&id=c3cfb74c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports